<template>
  <v-dialog v-model="dialog" width="1280" :scrollable="true">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn large icon v-on="{ ...tooltip, ...dialog }">
            <v-icon>mdi-account-supervisor</v-icon>
          </v-btn>
        </template>
        <span>Manage Roles</span>
      </v-tooltip>
    </template>

    <v-card raised class="modal-container pb-2">
      <v-toolbar flat dark color="primary">
        <v-toolbar-title>Manage Roles</v-toolbar-title>
        <v-progress-circular
          indeterminate
          color="white"
          v-if="updating === true"
        ></v-progress-circular>
        <span v-else></span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="permissions-modal-info-wrapper">
        <p v-if="loading">Loading Users...</p>
        <div v-else class="users-container">
          <div
            class="user-block"
            v-for="(user, index) in users"
            :key="user.name"
          >
            <div class="name-role-container">
              <div class="user-name">{{ user.name || user.email }}</div>
              <v-select
                class="role-selector"
                v-model="users[index].role"
                :items="
                  roles.map((role) => {
                    return role;
                  })
                "
                @change="changeRole(index)"
                filled
                :label="user.role"
              ></v-select>
            </div>
            <div class="projects-selector">
              <v-select
                :items="projects"
                item-text="name"
                item-value="id"
                v-model="activeProjects"
                attach
                chips
                @change="changeProjects(index)"
                label="Accessible Projects"
                multiple
              ></v-select>
            </div>
          </div>
        </div>

        <div class="permissions-footer-container">
          <v-btn class="submit-button" color="primary" @click="submitChanges"
            >Submit</v-btn
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import APIService from "@/services/APIService.js";
import { mapGetters } from "vuex";
import store from "@/store/";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      loading: false,
      updating: false,
      users: [],
      roles: ["IC", "ADMIN"],
    };
  },

  methods: {
    getProjects() {
      console.log(this.$store.getters["projects/activeProjects"]);
    },
    changeRole(userIndex) {
      console.log(this.users[userIndex]);
    },

    changeProjects(userIndex) {
      console.log(this.users[userIndex].projects);
    },

    submitChanges() {
      //Most a post request to the API in ./APIservices.js
      //Containing the data of the new user changes

      //Remove the 'role' attribute and change the admin attribute to a 1 or 0

      //let newUsersArray = [...this.users];
      let newUsersArray = JSON.parse(JSON.stringify(this.users));
      newUsersArray.forEach((user) => {
        if (user.role === "ADMIN") {
          user.admin = 1;
        } else {
          user.admin = 0;
        }

        user.projects = JSON.stringify(user.projects);

        delete user.role;
      });

      console.log(newUsersArray);
      console.log(this.users);
      this.updating = true;
      APIService.updateUsers(newUsersArray)
        .then((res) => {
          console.log(res);
          const notification = {
            type: "userUpdated",
            message: `User(s) Updated!`,
          };
          store.dispatch("notification/add", notification, { root: true });
          this.updating = false;
        })
        .catch((e) => {
          console.log(this.users);
          console.log(e);
        });
    },
    fetchUsers() {
      APIService.getUsers(null).then((res) => {
        console.log(res);
        let theUsers = res.data.results;
        theUsers.forEach((user) => {
          user.role = user.admin ? "ADMIN" : "IC";
          user.projects = JSON.parse(user.projects);
        });
        this.users = theUsers;
      });
    },
  },
  computed: {
    ...mapGetters({
      activeProjects: "projects/activeProjects",
    }),
    projects() {
      return this.activeProjects;
    },
  },
  created() {
    this.fetchUsers();
  },
};
</script>
<style>
.modal-container {
}
.permissions-modal-info-wrapper {
  position: relative;

  display: grid;
  grid-template-rows: 90% auto;

  overflow: hidden;
}

.permissions-footer-container {
}

.users-container {
  position: relative;
  width: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
  padding: 12px;
}
.user-block {
  position: relative;

  box-shadow: 0px 0px 2px 1px gray;
  border-radius: 3px;
  padding: 10px;
  margin-top: 20px;
  font-size: 22px;
}

.user-name {
  position: relative;

  display: inline-block;
  width: 300px;
}

.name-role-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 20px;
}

.role-selector {
  position: relative;
  display: inline-block;
  width: 200px !important;
  height: 57px;
  width: 200px !important;
}

.scroll-prevent {
  overflow: hidden !important;
  height: 420px;
}

.submit-button {
  position: absolute;
  bottom: 0px;
  width: 99%;
  height: 100px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
